import { render, staticRenderFns } from "./color_group_box_crosswise.vue?vue&type=template&id=1f1d7fba&scoped=true"
import script from "./color_group_box_crosswise.vue?vue&type=script&lang=ts"
export * from "./color_group_box_crosswise.vue?vue&type=script&lang=ts"
import style0 from "./color_group_box_crosswise.vue?vue&type=style&index=0&id=1f1d7fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d7fba",
  null
  
)

export default component.exports